<section class="invoice-doctor">
  <header class="invoice-doctor__header">
    <h1>NFS-e Médico</h1>
    <p class="invoice-doctor__subtitle">
      Listagem de pagamentos com NFS-e do médico pendente. Use o filtro de período
      e médicos para focar na ação inline.
    </p>
  </header>

  <form
    [formGroup]="filter"
    class="invoice-doctor__filters"
    (ngSubmit)="onSearch()"
  >
    <mat-form-field appearance="outline">
      <mat-label>Data inicial</mat-label>
      <input
        matInput
        [matDatepicker]="startPicker"
        formControlName="startDate"
        required
      />
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
      <mat-error *ngIf="filter.get('startDate')?.hasError('required')">
        Data inicial é obrigatória
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Data final</mat-label>
      <input
        matInput
        [matDatepicker]="endPicker"
        formControlName="endDate"
        required
      />
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
      <mat-error *ngIf="filter.get('endDate')?.hasError('required')">
        Data final é obrigatória
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="availableDoctors.length > 0">
      <mat-label>Médicos</mat-label>
      <mat-select formControlName="doctorIds" multiple>
        <mat-option *ngFor="let doc of availableDoctors" [value]="doc.id">
          {{ doc.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="loading || filter.invalid"
    >
      Buscar
    </button>
  </form>

  <div *ngIf="loading" class="invoice-doctor__state">
    <mat-spinner diameter="32"></mat-spinner>
    <span>Carregando registros…</span>
  </div>

  <div *ngIf="error && !loading" class="invoice-doctor__state invoice-doctor__state--error">
    {{ error }}
  </div>

  <div
    *ngIf="searched && !loading && !error && dataSource.data.length === 0"
    class="invoice-doctor__state"
  >
    Nenhum registro encontrado no período selecionado.
  </div>

  <table
    *ngIf="!loading && dataSource.data.length > 0"
    mat-table
    [dataSource]="dataSource"
    [trackBy]="trackByInvoice"
    class="invoice-doctor__table"
  >
    <ng-container matColumnDef="paidAt">
      <th mat-header-cell *matHeaderCellDef>Pagamento</th>
      <td mat-cell *matCellDef="let row">{{ row.paidAt | date: 'dd/MM/yyyy' }}</td>
    </ng-container>

    <ng-container matColumnDef="patient">
      <th mat-header-cell *matHeaderCellDef>Paciente</th>
      <td mat-cell *matCellDef="let row">{{ row.patient.name }}</td>
    </ng-container>

    <ng-container matColumnDef="doctor">
      <th mat-header-cell *matHeaderCellDef>Profissional</th>
      <td mat-cell *matCellDef="let row">{{ row.doctor.name || '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="doctorTransferAmount">
      <th mat-header-cell *matHeaderCellDef>Valor médico</th>
      <td mat-cell *matCellDef="let row">{{ formatCurrency(row.doctorTransferAmount) }}</td>
    </ng-container>

    <ng-container matColumnDef="indicationStatus">
      <th mat-header-cell *matHeaderCellDef>Atendimento</th>
      <td mat-cell *matCellDef="let row">
        <span *ngIf="row.row.status === 'BLOCKED'">{{ row.row.blockedReason }}</span>
        <span *ngIf="row.row.status !== 'BLOCKED'">Atendido</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="invoiceStatus">
      <th mat-header-cell *matHeaderCellDef>NFS-e</th>
      <td mat-cell *matCellDef="let row">
        <span [title]="row.invoice.lastFailureReason || ''">{{ row.invoice.status }}</span>
        <a
          *ngIf="row.invoice.pdfUrl"
          [href]="row.invoice.pdfUrl"
          target="_blank"
          rel="noopener"
          class="invoice-doctor__pdf"
        >PDF</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>Ação</th>
      <td mat-cell *matCellDef="let row">
        <ng-container [ngSwitch]="row.row.status">
          <button
            *ngSwitchCase="'ELIGIBLE'"
            [hidden]="true"
            mat-stroked-button
            color="primary"
            (click)="onEmit(row)"
          >
            {{ row.row.actionLabel || 'Emitir NFS-e' }}
          </button>

          <button
            *ngSwitchCase="'RETRY'"
            [hidden]="true"
            mat-stroked-button
            color="warn"
            (click)="onEmit(row)"
          >
            {{ row.row.actionLabel || 'Reemitir NFS-e' }}
          </button>

          <span
            *ngSwitchCase="'BLOCKED'"
            class="invoice-doctor__blocked"
            [title]="row.row.blockedReason || ''"
            aria-label="Linha bloqueada"
          >
            🔒
          </span>

          <mat-spinner *ngSwitchCase="'PROCESSING'" diameter="20"></mat-spinner>

          <span *ngSwitchCase="'DONE'" class="invoice-doctor__done" aria-label="NFS-e autorizada">
            ✅
          </span>

          <span *ngSwitchDefault>—</span>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</section>
